<div class="shipment-box layout-p-6 flexContent flexColumn gap-6 shipment-box--border-active"
    [class.shipment-box--is-scale-realised]="shipmentTask.IsScaleRealised">

    <div class="flexContent spacebetween">
        <div class="flexContent flexColumn gap-6">
            <div *ngIf="shipmentTask.Carrier">
                {{shipmentTask.Carrier }}
            </div>
            <div *ngIf="shipmentTask.BDO">
                {{shipmentTask.BDO}}
            </div>

            <div *ngIf="shipmentTask.PointName">
                {{shipmentTask.PointName}}
            </div>

            <div *ngIf="shipmentTask.Address">
                {{shipmentTask.Address}}
            </div>
        </div>
        <button type="button" mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>



    <div *ngIf="shipmentTask.Categories.length > 0">
        <span *ngFor="let category of shipmentTask.Categories; let first = first">
            <span *ngIf="!first">&nbsp;|&nbsp;</span> {{category.Title}}
        </span>
    </div>

    <div *ngIf="shipmentTask.WasteCodes.length > 0">
        <span *ngFor="let waste of shipmentTask.WasteCodes; let first = first">
            <span *ngIf="!first">&nbsp;|&nbsp;</span> {{waste.Title}}
        </span>
    </div>

    <div class="shipment-box__divider"></div>

    <div *ngIf="shipmentTask.DriverName">
        {{shipmentTask.DriverName}}
    </div>

    <div *ngIf="shipmentTask.DriverPhone">
        {{shipmentTask.DriverPhone}}
    </div>

    <div class="shipment-box__divider"></div>

    <div class="flexContent spacebetween align-center">
        <div>
            {{shipmentTask.VehicleNumber}} <span *ngIf="shipmentTask.TrailerNumber">/
                {{shipmentTask.TrailerNumber}}</span>
        </div>

        <delivery-type-icon [taskType] ="shipmentTask.TaskType" />
    </div>


    <mat-menu #menu="matMenu">
        <button mat-menu-item *ngIf="shipmentTask.IsScaleRealised" (click)="undoCompletion.emit(shipmentTask)">
            <mat-icon>keyboard_return</mat-icon>
            <span>Cofnij realizację</span>
        </button>

        <button mat-menu-item *ngIf="!shipmentTask.IsScaleRealised" (click)="markAsCompleted.emit(shipmentTask)">
            <mat-icon>check</mat-icon>
            <span>Zrealizuj</span>
        </button>

    </mat-menu>
</div>